import React, { useEffect, useState } from "react";
import { toast, Toaster } from "sonner";
import DashboardShell from "../../components/layout/DashboardShell";
import StartupCard from "../../components/marketplace/StartupCard";
import { EmptyState } from "../../components/common/Primitives";
import api, { formatApiError } from "../../lib/api";

export default function InvestorSaved() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/investor/saved").then((r) => setRows(r.data || []));
  useEffect(() => { load(); }, []);
  const express = async (s) => {
    try { await api.post("/investor/interest", { startup_id: s.startup_id }); toast.success("Interest expressed."); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <DashboardShell title="Saved Startups" subtitle="INVESTOR · WATCHLIST">
      <Toaster richColors position="top-right" />
      {rows.length === 0 ? (
        <EmptyState title="No saved startups yet" hint="Save startups from the Directory to build a private watchlist." />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {rows.map((s) => (
            <StartupCard key={s.startup_id} startup={{ ...s, locked: false, funding_ask: s.funding_ask, verified: s.status === "Approved" }} onExpressInterest={express} />
          ))}
        </div>
      )}
    </DashboardShell>
  );
}
